module.exports = __webpack_public_path__ + "img/02.9a06817a.png";